import React from 'react'
import config from '../../config.json'
import Page from '../page/Page'
import SearchComponent from '../searchitems/'
import { useTranslation } from 'react-i18next'

const Market = (props) => {
    const collectionDetails = props['collection_details']
    const collectionName = collectionDetails ? collectionDetails['name'] : null
    const preview = collectionDetails ? collectionDetails['preview'] : null

    const { t } = useTranslation('common')

    return (
        <Page
            id={'MarketPage'}
            title={config.titles.market.replace(
                '{collectionName}',
                collectionName ? 'for ' + collectionName : '',
            )}
            description={config.descriptions.market.replace(
                '{collectionName}',
                collectionName ? collectionName + ', ' : '',
            )}
            image={preview}
            banners={false}
            pageTitle={t('pages.wax_nft_marketplace')}
            pageSubtitle={t('pages.buy_and_sell_nfts_wax')}
            breadcrumbs={[
                {
                    title: 'Home',
                    link: '/',
                },
                {
                    title: 'Marketplace',
                    link: '/market',
                },
            ]}
            {...props}
        >
            <SearchComponent
                {...props}
                searchSettings={{
                    owner: '',
                    search_type: { value: 'listings', fixed: false },
                    order_by: { value: 'date_desc', fixed: false },
                    minimal: false,
                    tab: 'listings',
                    page_component: false,
                    limit: { value: 40, fixed: true },
                    expanded: false,
                }}
                limit={40}
                tab={'listings'}
            />
        </Page>
    )
}

export default Market
